import React from "react";
import { Box, Stack, Typography, styled, useTheme, useMediaQuery } from "@mui/material";
import Tooltip from "@hyro-components/Tooltip";
import CheckboxIcon from "src/icons/CheckBoxCheckedIcon";
import HyroTruncateTypography from "@hyro-components/hyro-truncate-typography/HyroTruncateTypography";

const StepIndicator = ({ active, completed, disabled, nextDisabled, isLast, number, label, tooltipText = "" }) => {
  const theme = useTheme();
  const isLargeSizeDevice = useMediaQuery(theme.breakpoints.up("lg"));
  const isLabelActive = (active || completed) && !disabled;
  const isLineActive = completed && !disabled && !nextDisabled;

  return (
    <Tooltip title={tooltipText} placement="top" tooltipStyle={{ width: "200px" }}>
      <StyledStepIndicator>
        <StyledStepNumber active={isLabelActive}>{completed ? <CheckboxIcon color="#fff" /> : number}</StyledStepNumber>
        <StyledStepLabel maxWidth={isLargeSizeDevice ? "100%" : "50px"} variant="caption" active={isLabelActive} data-testid={`step-label-${number}`}>{label}</StyledStepLabel>
        {!isLast && <StyledStepLine active={isLineActive} />}
      </ StyledStepIndicator>
    </Tooltip>
  );
};

export default StepIndicator;

const StyledStepIndicator = styled(Stack)(({ theme }) => ({
  flexDirection: "row",
  alignItems: "center",
  gap: theme.spacing(1)

}));

const StyledStepNumber = styled(Box, {
  shouldForwardProp: (prop) => prop !== "active"
})(({ theme, active }) => ({
  fontSize: "12px",
  color: "#FFFFFF",
  width: "24px",
  height: "24px",
  borderRadius: "50%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  fontWeight: "bold",
  overflow: "hidden",
  backgroundColor: active ? "#7583F7" : theme.palette.system[400]
}));

const StyledStepLabel = styled(HyroTruncateTypography, {
  shouldForwardProp: (prop) => prop !== "active"
})(({ theme, active }) => ({
  fontSize: "12px",
  color: active ? theme.palette.text[800] : theme.palette.system[500]
}));

const StyledStepLine = styled(Box, {
  shouldForwardProp: (prop) => prop !== "active"
})(({ theme, active }) => ({
  width: "75px",
  height: "2px",
  marginRight: "8px",
  backgroundColor: active ? "#7583F7" : theme.palette.system[400],
  borderRadius: theme.shape.borderRadius,
  [theme.breakpoints.down("lg")]: {
    width: "30px"
  }
}));
